var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    { staticClass: "space-y-4" },
    [
      _vm._l(_vm.value, function (area, index) {
        return _c("AreaForm", {
          key: area.id,
          attrs: {
            value: area,
            configurable: _vm.config[area.type].configurable,
            label: _vm.config[area.type].label,
          },
          on: {
            updated: function ($event) {
              return _vm.$emit("updated", { index, area: $event })
            },
            removed: function ($event) {
              return _vm.$emit("removed", { index })
            },
          },
        })
      }),
      _vm._v(" "),
      _vm.isSelectingAreaType
        ? _c(
            "div",
            {
              staticClass:
                "grid grid-cols-2 gap-x-4 gap-y-2 items-center px-2 sm:px-5 py-5 rounded-b-sm bg-cream bg-opacity-50",
            },
            [
              _c(
                "label",
                {
                  staticClass: "col-span-2 sm:col-span-1",
                  attrs: { for: "coating-area-type-select" },
                },
                [_vm._v("What is your area?")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-span-2 sm:col-span-1" },
                [
                  _c("SelectMenu", {
                    attrs: {
                      id: "coating-area-type-select",
                      options: _vm.areaTypeOptions,
                      value: null,
                      "test-id": "area-type-select",
                      placeholder: "Choose...",
                    },
                    on: { input: _vm.handleAreaTypeChange },
                  }),
                ],
                1
              ),
            ]
          )
        : _c("AddButton", {
            on: {
              click: function ($event) {
                _vm.isSelectingAreaType = true
              },
            },
          }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }